import { apiSlice } from '../../app/api/apiSlice';
import { EnvironmentCheckReport } from './types';

interface EnvironmentCheckLogPayload {
  collection: 'environment_check_log__c';
  data: {
    candidate__c: string;
    certification_log__c: string;
    overall_status__c: 'approved' | 'blocked';
    checks__c: Array<{
      check_id__c: string;
      check_name__c: string;
      status__c: string;
      details__c: string;
      timestamp__c: string;
      metadata__c?: Record<string, unknown>;
    }>;
    duration_ms__c: number;
    browser_info__c: {
      user_agent__c: string;
      platform__c: string;
      language__c: string;
    };
    created_at__c: string;
  };
}

export const environmentCheckApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ mutation }) => ({
    sendEnvironmentCheckLog: mutation<unknown, EnvironmentCheckLogPayload>({
      query: payload => ({
        url: 'database/environment_check_log__c',
        method: 'PUT',
        body: payload,
      }),
    }),
  }),
});

export const { useSendEnvironmentCheckLogMutation } = environmentCheckApiSlice;

/**
 * Converte um EnvironmentCheckReport para o payload de API com sufixo __c
 */
export function buildEnvironmentCheckPayload(
  report: EnvironmentCheckReport,
): EnvironmentCheckLogPayload {
  return {
    collection: 'environment_check_log__c',
    data: {
      candidate__c: report.candidateId,
      certification_log__c: report.certificationLogId,
      overall_status__c: report.overallStatus,
      checks__c: report.checks.map(c => ({
        check_id__c: c.checkId,
        check_name__c: c.checkName,
        status__c: c.status,
        details__c: c.details,
        timestamp__c: c.timestamp,
        metadata__c: c.metadata,
      })),
      duration_ms__c: report.durationMs,
      browser_info__c: {
        user_agent__c: report.browserInfo?.userAgent ?? navigator.userAgent,
        platform__c: report.browserInfo?.platform ?? navigator.platform,
        language__c: report.browserInfo?.language ?? navigator.language,
      },
      created_at__c: new Date().toISOString(),
    },
  };
}
